import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button as ReactButton } from '@a-ui/react';
import { DetailLayout } from 'components/DetailLayout';
import Link from 'components/Link';
import useConfig from 'hooks/config.hooks';
import { translate } from '../../../i18n';

const DeleteStrongProfile: React.FC<{}> = () => {
  const history = useHistory();
  const { PRIVACY_URL } = useConfig();

  const handleCancel = () => {
    history.push('/gegevens');
  };
  return (
    <DetailLayout
      backAction="/gegevens"
      backLabel="personal_data.overview.privacy.title"
      title="privacy.strongProfile.title"
      description="privacy.strongProfile.description"
    >
      <div className="ckp-a-privacy-form__buttons">
        <Link to={PRIVACY_URL}>
          <div className="u-margin-top">
            <ReactButton>{translate('privacy.strongProfile.toPrivacyPolicy')}</ReactButton>
          </div>
        </Link>
        <div className="u-margin-top">
          <ReactButton onClick={handleCancel}>{translate('common.button.cancel')}</ReactButton>
        </div>
      </div>
    </DetailLayout>
  );
};

export default DeleteStrongProfile;
